import { getQuoteResultFromQuoteId } from 'state/selectors/common/commonForm';
import type { AppState } from 'state/state.model';

export function getPriceImprovementExpanded(state: AppState, quoteId: string): boolean {
  return state.quotes.priceImprovementRequests[quoteId]?.isExpanded === true;
}

export function getPriceImprovementComment(state: AppState, quoteId: string): string | undefined {
  return state.quotes.priceImprovementRequests[quoteId]?.comment;
}

export function getPriceImprovementTraderComment(state: AppState, quoteId: string): string | undefined {
  return state.quotes.priceImprovementRequests[quoteId]?.traderComment;
}

export function getPriceImprovementReceivedTradingOffer(state: AppState, quoteId: string): number | undefined {
  const priceAdjustment = state.quotes.priceImprovementRequests[quoteId]?.priceAdjustment;
  const initialTradingOffer = getQuoteResultFromQuoteId(state, quoteId)?.priceEnhancement?.tradingOffer;
  if (priceAdjustment !== undefined && initialTradingOffer !== undefined) {
    return priceAdjustment + 100 * initialTradingOffer;
  }
  return undefined;
}

export function getPriceImprovementReceivedPriceAdjustment(state: AppState, quoteId: string): number | undefined {
  return state.quotes.priceImprovementRequests[quoteId]?.priceAdjustment;
}

export function getPriceImprovementRequestedTradingOffer(state: AppState, quoteId: string) {
  return state.quotes.priceImprovementRequests[quoteId]?.requestedTradingOffer;
}

export function getPriceImprovementExpirationTime(state: AppState, quoteId: string) {
  return state.quotes.priceImprovementRequests[quoteId]?.expirationTime;
}

export function getPriceImprovementStatus(state: AppState, quoteId: string) {
  return state.quotes.priceImprovementRequests[quoteId]?.status;
}

export function getPriceImprovementId(state: AppState, quoteId: string) {
  return state.quotes.priceImprovementRequests[quoteId]?.requestForPriceImprovementId;
}

export function getPriceImprovementCreationError(state: AppState, quoteId: string) {
  return state.quotes.priceImprovementRequests[quoteId]?.creationError;
}

export function getPriceImprovementCancellationError(state: AppState, quoteId: string) {
  return state.quotes.priceImprovementRequests[quoteId]?.cancellationError;
}
